module.exports = __webpack_public_path__ + "img/table_help_mobile.f365b6ad.png";